<template>
     <q-modal v-model="show_preview" :content-css="{maxWidth: getMaxWidth, minWidth: getMinWidth}" no-backdrop-dismiss no-esc-dismiss>
        <q-modal-layout>
            <q-toolbar slot="header">
                <q-btn flat round dense @click="show_preview = false" icon="fas fa-times" />
                <q-toolbar-title>
                    {{ $t(game_name) }}
                </q-toolbar-title>
            </q-toolbar>

            <div class="layout-padding">
                <div class="row q-pa-xs">
                    <div class="col-12">
                        <p class="text-bold">{{ $t('game_preview') }}</p>
                        <span v-for="(word, index) in game_words" :key="index">
                            <q-chip v-if="userOption(word, index)" square removable class="word-field font-bigger text-white bg-primary q-ma-xs cursor-pointer" :id="`chip-${index}`" @click="!game_finished ? removeWord(word, index) : null">
                                {{ `${word} ` }}
                                <q-icon v-if="!game_finished" style="font-size: 0.8rem;" class="q-pl-sm" name="fas fa-times" />
                            </q-chip>
                            <span v-else-if="word !== 'SPECIAL_WORD' && word.includes('\n')" class="font-bigger"><br />{{ `${word} ` }}</span>
                            <span v-else-if="word !== 'SPECIAL_WORD'" class="font-bigger">{{ `${word} ` }}</span>
                            <q-chip v-else square class="word-field font-bigger q-ma-xs" @drop.native="onDropWord(index)" @dragover.native="dragOverWord">{{ mapChoices(word, index) }}
                            </q-chip>
                        </span>
                    </div>

                    <div class="col-10 q-mt-lg" v-if="game_finished">
                        <p class="text-bold q-mt-sm">{{ $t('result') }}</p>

                        <q-slider disable markers snap
                            v-model="user_score" :color="game_finished ? getSliderColor() : 'blue-6'"
                            :min="0"
                            :max="number_of_choices"
                            />

                        <p class="q-mt-sm">{{ `${$t('correct_answers')}: ${user_score} / ${number_of_choices}` }}</p>
                        <p v-if="user_won">{{ $t(success_message) }}</p>
                        <p v-else>{{ $t(failure_message) }}</p>
                    </div>
                </div>

                <div v-if="options.length" class="col-xs-12 q-mt-lg q-ma-sm shadow-2 q-pa-md">
                    <p class="text-bold">{{ $t('words')}}</p>
                    <span class="q-my-sm q-mr-sm" v-for="(opt, index) in options" :key="index+'o'">
                        <q-chip class="word-options font-bigger q-ma-xs" square color="primary" text-color="white" draggable="true" @dragstart.native="dragStart(opt.text)">{{ opt.text }}</q-chip>
                    </span>
                </div>

                <div class="col-xs-12 q-mt-md">
                    <div class="row justify-end">
                        <q-btn color="secondary" :label="$t('back')" @click="show_preview = false" />
                        <q-btn v-if="!options.length" color="primary"  class="q-ml-md" :label="$t('play_again')" @click="resetGame" />
                    </div>
                </div>
            </div>
        </q-modal-layout>
    </q-modal>
</template>

<script>
export default {
    name: 'AdminGameDragTheWordsPreview',

    props: ['show_game_preview', 'game_name', 'game_words_arr', 'game_options', 'word_slot'],

    data() {
        return {
          user_answers: [],
          options: [],
          game_words: [],
          selected_word: '',
          game_finished: false,
          number_of_choices: 0,
          correct_choices: 0,
          user_score: 0,
          user_won: false,
          success_message: `${this.game_name}_success_message`,
          failure_message: `${this.game_name}_failure_message`,
        }
    },

    computed: {
        show_preview: {
            get() {
                return this.show_game_preview
            },
            set() {
                this.$emit('hide_preview', '')
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '90vw'
            else return '75vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '50vw'
        },
    },

    methods: {
        mapChoices(word, index) {
            return this.word_slot
        },

        userOption(word, index) {
            if (this.game_options.find(e => e.position === index)) {
                if (word === 'SPECIAL_WORD') return false
                else return true
            } else return false
        },

        getSliderColor() {
            let medium = Math.ceil(this.number_of_choices / 2)

            if (this.correct_choices < medium) return 'red-6'
            else if (this.correct_choices == medium) return 'blue-6'
            else return 'green-6'
        },

        dragStart(word) {
            this.selected_word = word
        },

        dragOverWord(e) {
            e.preventDefault()
        },

        onDropWord(index) {
            this.game_words[index] = this.selected_word

            this.user_answers.push({ text: this.selected_word, position: index, correct: undefined })
            this.options.splice(this.options.findIndex(w => w.text === this.selected_word), 1)

            if (this.options && !this.options.length) this.checkResults()
        },

        removeWord(word, index) {
            let match = this.user_answers.findIndex(e => e.position === index)

            if (match !== undefined) {
                this.game_words[index] = 'SPECIAL_WORD'
                this.user_answers.splice(match, 1)
                this.options.push({position: index, text: word })
            }
        },

        checkResults() {
            this.user_answers = this.user_answers.map(ans => {
                let match = this.game_options.find(e => e.position === ans.position)
                return {
                    ...ans,
                    correct: match.text === ans.text ? true : false
                }
            })

            this.game_finished = true

            let correctAnswers = this.user_answers.filter(e => e.correct).length

            setTimeout(() => {
                this.correct_choices = correctAnswers
                this.user_score = correctAnswers
                if (this.correct_choices >= this.number_of_choices) this.user_won = true
            }, 750);

            this.addResultStyles()
        },

        addResultStyles() {
            setTimeout(() => {
                this.user_answers.forEach(e => {
                    let word = document.querySelector(`#chip-${e.position}`)
                    if (word) {
                        if (word && e.correct) {
                            word.classList.remove('bg-primary')
                            word.classList.add('bg-green-4')
                        } else {
                            word.classList.remove('bg-primary')
                            word.classList.add('bg-red-4')
                        }
                    }
                })
            }, 0)
        },

        resetGame() {
            this.options = this.game_options.map(e => e)
            this.selected_word = this.word_slot
            this.correct_choices = 0
            this.user_score = 0
            this.user_won = false

            this.user_answers.forEach(e => {
                let word = document.querySelector(`#chip-${e.position}`)
                word.classList.remove('bg-red-4')
                word.classList.remove('bg-green-4')
                word.classList.add('bg-primary')
            });

            this.user_answers = []
            this.game_words = this.game_words_arr.map(e => e)
            this.game_finished = false
        }
    },

    mounted () {
        this.options = this.game_options.map(e => e)
        this.game_words = this.game_words_arr.map(e => e)
        this.number_of_choices = this.game_options.length
    },

}
</script>

<style lang="stylus" scoped>
.word-field
    font-weight bold
    margin: 0.25rem
    padding: 0.75rem

.word-options
    cursor grab
    padding 0.75rem

.font-bigger
    font-size 1.15rem

.bg-green-4 {
    transition all 1.25s ease
}

.bg-red-4 {
    transition all 1.25s ease
}
</style>
